var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M16.0003 29.3337C8.63633 29.3337 2.66699 23.3643 2.66699 16.0003C2.66699 8.63633 8.63633 2.66699 16.0003 2.66699C23.3643 2.66699 29.3337 8.63633 29.3337 16.0003C29.3337 23.3643 23.3643 29.3337 16.0003 29.3337ZM16.0003 26.667C18.8293 26.667 21.5424 25.5432 23.5428 23.5428C25.5432 21.5424 26.667 18.8293 26.667 16.0003C26.667 13.1713 25.5432 10.4582 23.5428 8.45785C21.5424 6.45747 18.8293 5.33366 16.0003 5.33366C13.1713 5.33366 10.4582 6.45747 8.45785 8.45785C6.45747 10.4582 5.33366 13.1713 5.33366 16.0003C5.33366 18.8293 6.45747 21.5424 8.45785 23.5428C10.4582 25.5432 13.1713 26.667 16.0003 26.667ZM9.33366 12.0003L13.3337 7.33366L17.3337 12.0003H14.667V17.3337H12.0003V12.0003H9.33366ZM22.667 20.0003L18.667 24.667L14.667 20.0003H17.3337V14.667H20.0003V20.0003H22.667Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap_icon.5be274536f34b4effdce2175170b5d2c.svg";
export { ForwardRef as ReactComponent };